import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { AuthorCollectingSocietyListStore } from "../../store/AuthorCollectingSocietyListStore";

type AuthorCollectingSocietyListDialogsProps = {
  store: AuthorCollectingSocietyListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de AuthorCollectingSociety.
 * Separado para mantener AuthorCollectingSocietyListPage más limpio.
 */
export const AuthorCollectingSocietyListDialogs: React.FC<AuthorCollectingSocietyListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
